export enum HOME_TYPE { 
	HDB = 'HDB',
	CONDO = 'Condo',
	LANDED = 'Landed',
	OTHER = 'Other'
}

export enum HOME_SIZE { 
	STUDIO = 'Studio',
	ONE = '1 Bed',
	TWO = '2 Bed',
	THREE = '3 Bed',
	FOUR = '4 Bed',
	FIVE_PLUS = '5+ Beds',
}

export enum BUDGET { 
	LOW = '1-10K',
	MED = '10-50K',
	HIGH = '50-100K',
	VERY_HIGH = '100K+'
}